import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import AuthService from './state/auth.service';
const AdminRoute = ({ component: Component, ...attrs }) => {
    let isAnAdmin = false;

    // Authenticate the user.
    const isAuthenticated = AuthService.isAuthenticated() === true;
    // Get the user.
    const user = AuthService.getUser();

    if (user) {
        const role = user.role || null;

        // If the role is Restricted and the prop restricted is true.
        const isRestrictedConsultant = role === 'Restricted' && attrs.restricted === true;

        const hasCorrectRole = role === 'Administrator' || isRestrictedConsultant;

        // This Route can be used if the role is an Administrator or isRestrictedConsultant is true.
        isAnAdmin = isAuthenticated && hasCorrectRole;
    }

    return <Route {...attrs} render={props => (isAnAdmin ? <Component {...props} /> : <Redirect to="/" />)} />;
};

export default AdminRoute;
